const defaultItemText = {
  type: 'text',
  value: '自由に文章が入力できます。\n左下から、テキストの追加もしくは、ソーシャルボタンの設置ができます。',
  scale_x: 1,
  scale_y: 1,
  scale_z: 1,
  x: 0,
  y: 0,
  z: 1.6,
  font_size: 18,
  color: '#000',
  background_color: '',
  align: 'left',
  width: 3,
  height: 2,
  padding_top: 0,
  padding_right: 0,
  padding_bottom: 0,
  padding_left: 0,
}

export default defaultItemText
